




















































import Vue from 'vue'
import Converter from './components/Converter.vue'

export default Vue.extend({
  name: 'App',

  components: {
    Converter
  },

  data: () => ({
    // links: [
    //   { name: 'Spencer Woo', link: 'https://spencerwoo.com' },
    // ]
  })
})
